import { GeckoAvatar } from 'ui';
import React from 'react';

const TeamOption = (props) => {
  const { name } = props;
  return (
    <div className="TableTeamSelect-TeamOption">
      <GeckoAvatar size={'sm'} name={name} />
      &nbsp;{name}
    </div>
  );
};
export default TeamOption;
